<template>
  <el-dialog
    title=""
    :visible.sync="isShowMap"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @closed="mapClosed"
    custom-class="map-location-dialog"
  >
    <h1 class="location-name">
      温馨提示！若自动获取的地点不对，可以通过地址或关键词搜索。搜索请带”地铁站“如：黄土岭地铁站
    </h1>
    <div class="search-group">
      <el-input v-model="keyword" placeholder="请输入城市名称" @keyup.enter.native="searchLocation"></el-input>
      <el-button class="search-btn-local" type="primary" @click="searchLocation">搜索</el-button>
    </div>
    <div id="l-map" class="map-container"></div>
  </el-dialog>
</template>
<script>
import { getSitesAutoComplete } from '@/service/site';
import { loadBMap } from "@/utils/loadBMap.js";
export default {
  name: "Map",
  props: {
    callback: Function, // 选中地区回调
  },
  data() {
    return {
      isShowMap: false,
      keyword: '',
      point_lng: '',
      point_lat: '',
      map:'',
      ak:'nRiAbKC245QLSOiFInQgqTU7'
    };
  },
 async mounted() {
    await loadBMap(this.ak) 
  },  
  methods: {
    openDialog (lng, lat, city) {
      this.isShowMap = true
      this.point_lng = lng || '';
      this.point_lat = lat || '';
      this.siteName = city;
      this.$nextTick(() => {
          this.init();
      })
    },
    init () {
      this.map = new BMapGL.Map("l-map");
        const vpoint = new BMapGL.Point(this.point_lng, this.point_lat);
        //this.map.centerAndZoom(this.siteName, 14);
        //如果输入框有坐标 则显示该坐标地图
        if(this.point_lng !== '' && this.point_lat !== '') {
            this.map.centerAndZoom(vpoint, 16);
            this.map.addOverlay(new BMapGL.Marker(vpoint));
            this.initMapOther();
        } else {
          this.currentLocation();
        }
     
    },
    /** 初始化地图其他参数 */
    initMapOther () {
      this.map.enableScrollWheelZoom();//启用滚轮放大缩小
      this.map.addEventListener("click", e => {
        this.map.clearOverlays();//清除所有标注图层覆盖物
        var point = new BMapGL.Point(e.point.lng, e.point.lat);//初始化
        this.map.addOverlay(new BMapGL.Marker(point)); //添加图层覆盖物
        //将坐标显示到文本框
        this.callback && this.callback(e.point.lng, e.point.lat);
      });
      //比例调节条
      this.map.enableScrollWheelZoom();
      const opts = {type: BMAP_NAVIGATION_CONTROL_LARGE}
      this.map.addControl(new BMapGL.NavigationControl(opts)); 
    },
    /** 当前定位 */
    currentLocation () {
      // 获取当前城市定位坐标
      const _this = this;
      const geoc = new BMapGL.Geolocation();
      geoc.getCurrentPosition(function (r) {
        if (this.getStatus() === BMAP_STATUS_SUCCESS) {
          const point = new BMapGL.Point(r.longitude, r.latitude);
          _this.map.centerAndZoom(point, 16);
          _this.initMapOther()
        }
      })
    },
    /** 搜索定位 */
    searchLocation () {
      const _this = this;
      if (this.keyword.trim() === '') {
        this.currentLocation();
        return null;
      }
      const myGeo = new BMapGL.Geocoder()
      this.map.centerAndZoom(this.siteName, 14);
      var options = {
        onSearchComplete: function(results){
          // 判断状态是否正确
          if (local.getStatus() == BMAP_STATUS_SUCCESS){
            _this.map.clearOverlays();//清除所有标注图层覆盖物
            let point=results._pois[0].point
            let pointA= new BMapGL.Point(point.lng, point.lat)
            _this.map.addOverlay(new BMapGL.Marker(point));
            _this.map.centerAndZoom(point, 16);
            _this.callback && _this.callback(point.lng, point.lat);
            _this.initMapOther()
            
          }
        }
      };
      var local = new BMapGL.LocalSearch(this.map, options);
      _this.keyword=_this.keyword
      local.search(this.keyword);
    },
    /** 销毁地图 */
    mapClosed () {
      this.map = null
      this.keyword = ''
    }
  }
};
</script>
<style lang="less">
.map-location-dialog {
  .el-dialog__header {
    padding: 0;
  }
  .location-name{
    max-width: 90%;
    line-height: 20px;
  }
  .search-group {
    display: -webkit-box;
    margin-top: 20px;
    .el-input {
      display: block;
      max-width: 400px;
      width: 70%;
    }
    .search-btn-local {
      display: block;
      margin-left: 15px;
    }
  }
  .map-container{
      height: 400px;
      width: 100%;
      margin-top: 20px;
  }
}
</style>
